import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Dream</div>
                                                <ul className="greenbullet-list">
                                                    <li>Ask the individual to consider an area of their work in
                                                        which they would like to improve – where they are either
                                                        underperforming or just performing to a satisfactory
                                                        level.
                                                    </li>
                                                    <li>Ask them to think of a broad, ideal goal which they
                                                        would like to move towards, for example ‘I would like to
                                                        get a promotion’.
                                                    </li>
                                                    <li>Ask the individual to visualise what they would be like
                                                        if they applied their strengths to the chosen area.
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Design</div>
                                                <ul className="greenbullet-list">
                                                    <li>Explore what the individual would need to do in order to
                                                        use more of their strengths in the chosen area of work.
                                                        For example, rely more on building personal
                                                        relationships to increase sales, use the same creativity
                                                        that is used for design projects to solve ‘people
                                                        problems’, etc.
                                                    </li>
                                                    <li>Explore whether there are ways that the individual’s job
                                                        needs to develop in order to use more of their
                                                        strengths; for example, delegating more administrative
                                                        work to allow time for more project management, or
                                                        taking on a role in a team project for an afternoon a
                                                        week.
                                                    </li>

                                                </ul>
                                            </div>

                                            <div className="lightgreencontentbg ">
                                                <div className="border_subtitle">Deliver</div>
                                                <ul className="greenbullet-list">
                                                    <li>Together, work out a list of actions necessary to ensure
                                                        the ideas you have generated are put into practice –
                                                        make these Specific, Measurable, Achievable, Realistic
                                                        and Time-limited (SMART).
                                                    </li>
                                                    <li>Agree what you will need to do to support the individual
                                                        to achieve their actions.
                                                    </li>
                                                    <li>Agree on how you will monitor progress.</li>
                                                </ul>
                                            </div>
                                            <br/>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>SBI MODEL
                                            </div>
                                            <p>The SBI model could help you to structure your feedback and
                                                help you plan for success when delivering it. SBI stands for
                                                ‘Structure’, ‘Behaviour’ and ‘Impact’, explained in more
                                                detail below.</p>
                                            <div className="border_subtitle">Structure</div>
                                            <p>Make sure that you have made clear what the feedback is about
                                                and how you intend to present it.</p>
                                            <p><span className="subtiltereg">Example Actions:</span> Make
                                                clear which situation you are referring to when providing
                                                feedback, e.g. ‘yesterday you were late to a meeting’.
                                                Provide objective evidence which can be examined: ‘you
                                                entered at 10.15am rather than the scheduled 10.00am’.</p>
                                            <p>Think about how you’re going to introduce the issues, and
                                                what points you are going to mention, and in which
                                                order.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}